import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ATTACHMENT_API } from "./apiRoutes";

interface UseGetAttachmentByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getAttachmentById = async (id: string) =>
  await axiosAuth.get(`${ATTACHMENT_API}/presigned-url/${id}`);

const useGetAttachmentById = ({
  queryParams,
  id,
}: UseGetAttachmentByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["attachment-by-id", id],
    queryFn: () => getAttachmentById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!id || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetAttachmentById;
